import PropTypes from "prop-types";
import React from "react";

import withTranslations from "../../../../../../hocs/withTranslations";
import formatPrice from "../../../../../../lib/TradingView/formatPrice";
import { SIGNAL_DETAIL_TYPES } from "../../../../../../lib/notifications/sidSignalDetailTypes";
import { SUPPLY_DEMAND_SIGNAL_DETAIL_TYPES } from "../../../../../../lib/notifications/supplyDemandSignalDetailTypes";
import FlexSeparatedRow from "../../../../common/FlexSeparatedRow";

const isPresent = value => value !== null && value !== undefined && value !== "";

const isEntryDetailType = detailType =>
  detailType === SIGNAL_DETAIL_TYPES.ENTRY ||
  detailType === SUPPLY_DEMAND_SIGNAL_DETAIL_TYPES.ENTRY;

const SidSignalLevelsRow = ({ config, translate }) => {
  if (!config || !isEntryDetailType(config.detail_type)) {
    return null;
  }

  const currency = config.currency;
  const items = [];

  if (isPresent(config.entry_price)) {
    items.push({
      key: "entry_price",
      label: translate("notification_signal_entry"),
      value: formatPrice({ value: config.entry_price, currency }),
      valueClassName: "font-bold"
    });
  }

  if (isPresent(config.tp)) {
    items.push({
      key: "tp",
      label: translate("notification_signal_first_take_profit"),
      value: formatPrice({ value: config.tp, currency }),
      valueClassName: "font-bold text-green"
    });
  }

  if (isPresent(config.sl)) {
    items.push({
      key: "sl",
      label: translate("notification_signal_stop_loss"),
      value: formatPrice({ value: config.sl, currency }),
      valueClassName: "font-bold text-red"
    });
  }

  if (isPresent(config.risk_reward)) {
    items.push({
      key: "risk_reward",
      label: translate("notification_signal_risk_reward"),
      value: String(config.risk_reward),
      valueClassName: "font-bold"
    });
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <FlexSeparatedRow
      className={"flex gap-x-4 gap-y-0.5 flex-row flex-wrap mt-1 mb-0.5"}
      itemClassName={"inline-flex gap-x-4"}
    >
      {items.map(item => (
        <span key={item.key} className={"text-sm font-medium"}>
          {item.label}:{" "}
          <span className={item.valueClassName}>{item.value}</span>
        </span>
      ))}
    </FlexSeparatedRow>
  );
};

SidSignalLevelsRow.propTypes = {
  config: PropTypes.shape({
    currency: PropTypes.string,
    detail_type: PropTypes.string,
    entry_price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    tp: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sl: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    risk_reward: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  translate: PropTypes.func.isRequired
};

export default withTranslations(SidSignalLevelsRow);
